import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc, useInvalidateRpcQueryFn } from '@/api/rpc/client';
import type { SuggestedActionType } from '@erp/shared-types';

interface ExecuteActionParams {
  suggestionId: string;
  actionIndex: number;
  stagedOrderId: string;
  actionType: SuggestedActionType;
  lineItemIndex?: number;
  lineItemIdentifier?: string;
  newPrice?: number;
  // For update_order_dates action
  deliveryDate?: string;
  shipDate?: string;
  // For update_ship_to_location action
  locationId?: string;
}

export function useExecuteSuggestedAction(onSuccess?: () => void) {
  const queryClient = useQueryClient();
  const invalidateRpcQueries = useInvalidateRpcQueryFn((orpc) => [
    orpc.ai.suggestions.get.key(),
    orpc.ai.suggestions.getByEntity.key(),
    orpc.accountsReceivable.salesOrderDrafts.validateDiscounts.key(),
    orpc.core.activityLog.list.key(),
  ]);

  return useMutation({
    ...orpc.ai.suggestions.executeAction.mutationOptions(),
    onSuccess: () => {
      invalidateRpcQueries();
      queryClient.invalidateQueries({
        queryKey: ['accounts-receivable', 'sales-order-drafts'],
      });
      onSuccess?.();
    },
  });
}

export type { ExecuteActionParams };
